import React from 'react';
import { Box, Typography } from '@mui/material';
import AdminNavBarComponent from '../../components/admin/AdminNavBarComponent'; // Ajuste le chemin selon l'organisation de ton projet
import ProgramManagementComponent from '../../components/admin/ProgramManagementComponent'; // Ajuste le chemin selon l'organisation de ton projet

const AdminPrograms = () => {
  return (
    <Box>
        <AdminNavBarComponent />
    <ProgramManagementComponent />
</Box>
  );
};

export default AdminPrograms;
